import { createResource } from 'react-resource-router';

import {
  FLAKY_DETECTION_FLAKY_SCORE_DEFAULT,
  MINIMUM_TEST_EXECUTIONS_DEFAULT,
  QUARANTINE_FLAKY_SCORE_DEFAULT,
} from 'src/components/pipelines/components/test-management';
import { fetchData } from 'src/components/pipelines/resources/utils';
import { getTestsConfigUrl } from 'src/components/pipelines/utils/links';
import { SentryPipelinesTeam } from 'src/components/pipelines/utils/sentry';

export type TestsSettings = {
  autoFlakyDetectionEnabled: boolean;
  autoFlakyDetectionThreshold: number;
  autoFlakyDetectionMinimumTestExecutions: number;
  autoQuarantineDetectionEnabled: boolean;
  autoQuarantineDetectionThreshold: number;
  autoQuarantineDetectionMinimumTestExecutions: number;
};

export const loadTestsSettingsResource = createResource<TestsSettings>({
  type: 'testsSettings',
  getKey: ({ match }) => getTestsConfigUrl(match.params),
  getData: async ({ match }) => {
    const testsSettings = await fetchData(
      getTestsConfigUrl(match.params),
      'tests_settings_resource_exception',
      {},
      'json',
      SentryPipelinesTeam.Mangalyaan
    );

    const flakyConfig = testsSettings?.auto_flaky_detection_config;
    const quarantineConfig =
      testsSettings?.auto_quarantine_detection_config ??
      flakyConfig?.auto_quarantine_detection_config;

    return {
      autoFlakyDetectionEnabled: flakyConfig?.enabled ?? false,
      autoFlakyDetectionThreshold:
        flakyConfig?.threshold ?? FLAKY_DETECTION_FLAKY_SCORE_DEFAULT,
      autoFlakyDetectionMinimumTestExecutions:
        flakyConfig?.minimum_test_executions ?? MINIMUM_TEST_EXECUTIONS_DEFAULT,
      autoQuarantineDetectionEnabled: quarantineConfig?.enabled ?? false,
      autoQuarantineDetectionThreshold:
        quarantineConfig?.threshold ?? QUARANTINE_FLAKY_SCORE_DEFAULT,
      autoQuarantineDetectionMinimumTestExecutions:
        quarantineConfig?.minimum_test_executions ??
        MINIMUM_TEST_EXECUTIONS_DEFAULT,
    };
  },
});
